module.exports = __webpack_public_path__ + "img/marker.81188295.svg";